export function receivedCentavos(value: string): number | null {
  if (!/^\d+(\.\d{1,2})?$/.test(value.trim())) return null;
  const [whole, fraction = ''] = value.trim().split('.');
  const result = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(result) && result > 0 ? result : null;
}
export async function refreshAdminFinances(client: { invalidateQueries: (filter: { queryKey: string[] }, options?: { throwOnError: boolean }) => Promise<unknown> }) {
  await Promise.all(['remittances', 'rider-finances', 'admin-reports', 'admin-rider-management', 'admin-rider-financial-details', 'audit']
    .map(key => client.invalidateQueries({ queryKey: [key] }, { throwOnError: true })));
}
